export default __webpack_public_path__ + "static/theatre-7d00a94c3e909069f4d25fdc1186e7b0.png";